/**
 * app-search — types + validator for layout `/u/$u` global search-state.
 *
 * Centralizes addressable layout-level overlays in the URL. Currently
 * only the account switcher (multi-account #18), opened via
 * `?account=switch`. `validateSearch` omits defaults to avoid polluting the URL
 * in empty state and discards unknown values (without breaking render).
 */

export interface AppLayoutSearch {
  // ── Account switch (multi-account #18) ─────────────────────────────────────
  /** Account switcher open (`?account=switch`).*/
  account?: "switch";
}

/**
 * Validates + normalizes layout search. Tolerant: unknown values are
 * discarded. Preserves other unknown keys as-is to avoid breaking
 * sub-routes with their own search (e.g. chronos).
 */
export function validateAppLayoutSearch(search: Record<string, unknown>): AppLayoutSearch {
  const out: AppLayoutSearch = {};
  if (search.account === "switch") {
    out.account = "switch";
  }
  return out;
}
